import Config from '@/config';

export const IS_PE_COUNTRY = Config.COUNTRY_CODE === 'pe';
export const IS_MX_COUNTRY = Config.COUNTRY_CODE === 'mx';
